import { useState, useCallback, useMemo } from 'react';
import { DEFAULT_PAGE_SIZE } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
/* istanbul ignore next */
export const usePerformancePage = ({
  assets, loadNextPage, adsStudioUserPreferences, totalAssetCount, highlightedText,
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const onPageChange = useCallback((number) => {
    if (assets && assets.length >= number * pageSize) {
      // there are enough loaded assets
      setPageNumber(number);
    } else {
      loadNextPage(pageSize).then(() => {
        setPageNumber(number);
      });
    }
  }, [assets, loadNextPage, pageSize]);

  const onPageSizeChange = useCallback((size) => {
    setPageNumber(1);
    setPageSize(size);
    if (adsStudioUserPreferences) {
      adsStudioUserPreferences.setPerfTablePageSize(size);
    }
  }, [adsStudioUserPreferences, setPageSize]);

  const pager = useMemo(() => ({
    pageNumber,
    pageSize,
    total: totalAssetCount,
    onPageChange,
    onPageSizeChange,
  }), [onPageChange, onPageSizeChange, pageNumber, pageSize, totalAssetCount]);

  const pagedItems = useMemo(
    () => {
      if (assets) {
        const items = assets.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
        // append search text filter to items, to highligh the text
        return items.map(itm => ({ ...itm, highlightedText }));
      }
      return [];
    },
    [assets, highlightedText, pageNumber, pageSize]
  );

  return {
    pageSize,
    pager,
    pagedItems,
    setPageNumber,
    setPageSize,
  };
};
